// extracted by mini-css-extract-plugin
export default {"blink_me":"RemainingTime_blink_me__g013L","blinker":"RemainingTime_blinker__m3DhW","Timer-Button":"RemainingTime_Timer-Button__Tq8+g"};